/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type STORY_MODE = "COMMENTS" | "QA" | "RATINGS_AND_REVIEWS" | "%future added value";
export type TabBarContainer_story = {
    readonly canModerate: boolean;
    readonly settings: {
        readonly mode: STORY_MODE;
    };
    readonly " $refType": "TabBarContainer_story";
};
export type TabBarContainer_story$data = TabBarContainer_story;
export type TabBarContainer_story$key = {
    readonly " $data"?: TabBarContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"TabBarContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TabBarContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canModerate",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "StorySettings",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mode",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = 'dff45bc796836487cfe9372f831f4785';
export default node;
